import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { useCurrency } from '@oolio-group/localization';
import { getStyles } from './PaymentStatus.styles';
import { useTheme } from '../../../hooks/useTheme';
import IconPayStatus from '../../../component/Icon/IconPayStatus';

interface Props {
  status: 'awaiting' | 'error' | 'processing';
  amountDue: number;
  onDismiss?: () => void;
}

const PaymentStatus: React.FC<Props> = ({ status, amountDue, onDismiss }) => {
  const { colors } = useTheme();
  const styles = useMemo(() => getStyles(colors), [colors]);
  const { formatCurrency } = useCurrency();

  const isError = status === 'error';
  const isProcessing = status === 'processing';

  return (
    <View style={styles.container}>
      <View style={styles.text}>
        <Text style={[styles.title, isError && styles.titleError]}>
          {isError
            ? 'Payment Unsuccessful!'
            : isProcessing
            ? 'Processing Payment...'
            : 'Tap, Insert or Swipe Card!'}
        </Text>
        {isError && (
          <Text style={styles.subtitle}>
            Refer to the payment terminal for more information.
          </Text>
        )}
      </View>
      <IconPayStatus status={isError ? 'error' : 'default'} />
      <View style={styles.amountGroup}>
        <View style={styles.text}>
          <Text style={styles.subtitle}>Amount Due</Text>
          <Text style={styles.value}>{formatCurrency(amountDue)}</Text>
        </View>
        {isError && onDismiss && (
          <TouchableOpacity
            testID="paymentStatusDismissBtn"
            style={styles.dismissBtn}
            onPress={onDismiss}
          >
            <Text style={styles.dismissBtnText}>Try Again</Text>
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
};

export default PaymentStatus;
